import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SubNavListColumn from './SubNavListColumn';

const StyledSubNavList = styled.div`
	display: flex;
	flex-direction: row;
`;

class SubNavList extends PureComponent {
	render() {
		const { items, type, slug, ...props } = this.props;

		return (
			<StyledSubNavList>
				{items.map((col, n) => (
					<SubNavListColumn
						key={n}
						type={type}
						title={col["title"]}
						items={col["items"]}
						parentSlug={slug}
						{...props}
					/>
				))}
			</StyledSubNavList>
		);
	}

	static propTypes = {
		slug: PropTypes.string.isRequired,
		items: PropTypes.arrayOf(PropTypes.object),
		type: PropTypes.string,
	}

	static defaultProps = {
		type: "category",
	}
}

export default SubNavList;
